const DOCUMENT = 'EDIT_BACKUPS_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  CANCEL: DOCUMENT + 'CANCEL',
  TOUCH: DOCUMENT + 'TOUCH',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  SET_REASON_ENABLED: DOCUMENT + 'SET_REASON_ENABLED',
  VALIDATE: DOCUMENT + 'VALIDATE',
  CHECK_CANCELLATION_POLICIES_REQUEST: DOCUMENT + 'CHECK_CANCELLATION_POLICIES_REQUEST',
  CHECK_CANCELLATION_POLICIES_SUCCESS: DOCUMENT + 'CHECK_CANCELLATION_POLICIES_SUCCESS',
  TOGGLE_CANCELLATION_POLICY_CONFIRMATION_MODAL: DOCUMENT + 'TOGGLE_CANCELLATION_POLICY_CONFIRMATION_MODAL',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  saveSuccess: () => ({
    type: actions.SAVE_SUCCESS,
  }),

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  loadFormData: data => ({
    type: actions.LOAD_FORM_DATA,
    payload: data,
  }),

  loadFormDataSuccess: data => ({
    type: actions.LOAD_FORM_DATA_SUCCESS,
    payload: data,
  }),

  setReasonEnabled: data => ({
    type: actions.SET_REASON_ENABLED,
    payload: data,
  }),

  validate: data => ({
    type: actions.VALIDATE,
    payload: data,
  }),

  checkCancellationPoliciesRequest: data => ({
    type: actions.CHECK_CANCELLATION_POLICIES_REQUEST,
    payload: data,
  }),

  checkCancellationPoliciesSuccess: data => ({
    type: actions.CHECK_CANCELLATION_POLICIES_SUCCESS,
    payload: data,
  }),

  toggleCancellationPolicyModal: data => ({
    type: actions.TOGGLE_CANCELLATION_POLICY_CONFIRMATION_MODAL,
    payload: data,
  }),
};

export default actions;
